
import Index from "@/pages/Index";
import Contact from "@/pages/Contact";
import NosServices from "@/pages/nos-services";
import NotFound from "@/pages/NotFound";
import LocationBennes from "@/pages/nos-services/LocationBennes";
import AchatMetaux from "@/pages/nos-services/AchatMetaux";
import Demolition from "@/pages/nos-services/Demolition";
import PrestationRSE from "@/pages/nos-services/PrestationRSE";
import Recyclage from "@/pages/nos-services/index";
import Metiers from "@/pages/metiers/MetiersIndex";
import MentionsLegales from "@/pages/legal/MentionsLegales";
import PolitiqueConfidentialite from "@/pages/legal/PolitiqueConfidentialite";
import Accessibilite from "@/pages/Accessibilite";
import Sitemap from "@/pages/NotFound";
import MetauxFerreux from "@/pages/valorisation/MetauxFerreux";
import MetauxNonFerreux from "@/pages/valorisation/MetauxNonFerreux";
import DEEE from "@/pages/valorisation/DEEE";
import PapiersCartons from "@/pages/valorisation/PapiersCartons";
import DIB from "@/pages/valorisation/DIB";
import ValorisationIndex from "@/pages/valorisation/ValorisationIndex";
import ProfessionDetails from "@/pages/metiers/MetierDetail";
import GaragisteDetail from "@/pages/metiers/GaragisteDetail";
import Sites from "@/pages/Sites";
import SiteDetails from "@/components/sites/SiteDetailPage";
import ValoGuide from "@/pages/ValoGuide";
import Histoire from "@/pages/Histoire";
import Engagements from "@/pages/Engagements";
import Recrutement from "@/pages/Recrutement";
import Valocap from "@/pages/Valocap";
import EstimationMetaux from "@/pages/EstimationMetaux";
import MetauxFerreuxLocation from "@/pages/valorisation/MetauxFerreuxLocation";
import DepartmentPage from "@/pages/geographic/DepartmentPage";
import CityPage from "@/pages/geographic/CityPage";
// Nouvelles pages de services
import Collectivites from "@/pages/services/Collectivites";
import Particuliers from "@/pages/services/Particuliers";
import Professionnels from "@/pages/services/Professionnels";
import Vehicules from "@/pages/services/Vehicules";
import ServicesIndex from "@/pages/services/ServicesIndex";
import OccitanieIndex from "@/pages/geographic/OccitanieIndex";
import ValorisationGuide from "@/pages/valorisation/ValorisationGuide";

// Main routes
export const mainRoutes = [
  { path: "/", element: Index },
  { path: "/contact", element: Contact },
  { path: "/valoguide", element: ValoGuide },
  { path: "/nos-services", element: NosServices },
  { path: "/nos-services/location-bennes", element: LocationBennes },
  { path: "/nos-services/achat-metaux", element: AchatMetaux },
  { path: "/nos-services/demolition", element: Demolition },
  { path: "/nos-services/prestation-rse", element: PrestationRSE },
  { path: "/nos-services/recyclage", element: Recyclage },
  { path: "/nos-metiers", element: Metiers },
  { path: "/nos-metiers/garagiste", element: GaragisteDetail },
  { path: "/metiers/garagiste", element: GaragisteDetail },
  { path: "/metiers/electricien", element: ProfessionDetails },
  { path: "/nos-metiers/electricien", element: ProfessionDetails },
  { path: "/metiers/agroalimentaire", element: ProfessionDetails },
  { path: "/nos-metiers/agroalimentaire", element: ProfessionDetails },
  { path: "/metiers/automobile", element: ProfessionDetails },
  { path: "/nos-metiers/automobile", element: ProfessionDetails },
  // Ajout de toutes les routes métiers manquantes
  { path: "/metiers/peintre", element: ProfessionDetails },
  { path: "/nos-metiers/peintre", element: ProfessionDetails },
  { path: "/metiers/plombier", element: ProfessionDetails },
  { path: "/nos-metiers/plombier", element: ProfessionDetails },
  { path: "/metiers/menuisier", element: ProfessionDetails },
  { path: "/nos-metiers/menuisier", element: ProfessionDetails },
  { path: "/metiers/carreleur", element: ProfessionDetails },
  { path: "/nos-metiers/carreleur", element: ProfessionDetails },
  { path: "/metiers/chauffagiste", element: ProfessionDetails },
  { path: "/nos-metiers/chauffagiste", element: ProfessionDetails },
  { path: "/metiers/restaurateur", element: ProfessionDetails },
  { path: "/nos-metiers/restaurateur", element: ProfessionDetails },
  { path: "/metiers/boulanger", element: ProfessionDetails },
  { path: "/nos-metiers/boulanger", element: ProfessionDetails },
  { path: "/metiers/construction", element: ProfessionDetails },
  { path: "/nos-metiers/construction", element: ProfessionDetails },
  { path: "/metiers/aeronautique", element: ProfessionDetails },
  { path: "/nos-metiers/aeronautique", element: ProfessionDetails },
  { path: "/metiers/pharmaceutique", element: ProfessionDetails },
  { path: "/nos-metiers/pharmaceutique", element: ProfessionDetails },
  { path: "/sites", element: Sites },
  { path: "/estimation-metaux", element: EstimationMetaux },
  // Nouvelles routes de services
  { path: "/services", element: ServicesIndex },
  { path: "/services/collectivites", element: Collectivites },
  { path: "/services/particuliers", element: Particuliers },
  { path: "/services/professionnels", element: Professionnels },
  { path: "/services/vehicules", element: Vehicules },
  // Nouvelle route Occitanie
  { path: "/occitanie", element: OccitanieIndex },
  // Nouveau guide valorisation
  { path: "/guide-valorisation", element: ValorisationGuide },
  // Route générique pour les métiers (doit être en dernier)
  { path: "/nos-metiers/:slug", element: ProfessionDetails },
];

// Group pages
export const groupRoutes = [
  { path: "/histoire", element: Histoire },
  { path: "/engagements", element: Engagements },
  { path: "/recrutement", element: Recrutement },
  { path: "/valocap", element: Valocap },
];

// Valorisation routes
export const valorisationRoutes = [
  { path: "/valorisation", element: ValorisationIndex },
  { path: "/valorisation/metaux-ferreux", element: MetauxFerreux },
  { path: "/valorisation/metaux-non-ferreux", element: MetauxNonFerreux },
  { path: "/valorisation/deee", element: DEEE },
  { path: "/valorisation/papiers-cartons", element: PapiersCartons },
  { path: "/valorisation/dib", element: DIB },
  { path: "/valorisation/metaux-ferreux/:location", element: MetauxFerreuxLocation },
];

// Geographic routes
export const geographicRoutes = [
  { path: "/services/departement/:departmentCode", element: DepartmentPage },
  { path: "/services/:departmentCode/:city", element: CityPage },
];

// Legal routes
export const legalRoutes = [
  { path: "/mentions-legales", element: MentionsLegales },
  { path: "/politique-de-confidentialite", element: PolitiqueConfidentialite },
  { path: "/accessibilite", element: Accessibilite },
  { path: "/sitemap.xml", element: Sitemap },
];

// Fallback route
export const fallbackRoute = { path: "*", element: NotFound };
